<template>
  <el-checkbox-group v-model="options" :textColor="color" :size='size' :name="name" @change="bindChange">
    <el-checkbox v-for="(item,index) in list" :key="index" :label="item[itemKey]" :disabled="disabled"
      :checked="item[itemKey] | getIsChecked(value)">
      {{item[itemValue]}}
    </el-checkbox>

    <!-- <el-input type="text" v-if="isShowInput" v-model="other" placeholder="请输入" style="width:130px;margin-left:4px;" /> -->
  </el-checkbox-group>
</template>

<script>
  export default {
    props: {
      name: {
        type: [String, Number],
        required: false,
      },
      // 数据数组
      list: {
        required: true,
      },
      // 页面上显示的值
      itemValue: {
        type: String,
        required: true,
      },
      // 传给后台的值再数据中的属性
      itemKey: {
        type: String,
        required: true,
      },
      // 传给后台的值
      value: {
        required: true,
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        required: false
      },
      color: {
        type: String,
        required: false,
      },
      size: {
        type: String,
        required: false,
      }
    },
    data() {
      return {
        options: [],
        isShowInput: false,
        other: '',
      }
    },
    watch: {
      value(val, oldVal) {
        if (typeof (val) === 'string') {
          this.options = val.split()
        } else {
          this.options = val
        }
      }
    },
    filters: {
      getIsChecked(item, value) {
        if (!value) {
          return false
        } else {
          return value.indexOf(item) != -1
        }
      }
    },
    methods: {
      bindChange(e) {
        //   if (e == '其他') {
        //     this.isShowInput = !this.isShowInput
        //   }
        this.$emit('input', e)
        this.$emit('change', e)
      }
    },
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ABcheckbox.vue